module.exports = __webpack_public_path__ + "img/american_credit_phone.6efb593.png";